<template>
  <div class="content_sidebar content_sidebar-right sidebar-showingDrawer" style="">
    <div class="sidebar_header l-flex-between">
      Docs
    </div>
    <div class="drawer-wrapper">
      <div class="accordion">
        <div class="docName">
          {{ documentFileName }}
        </div>
      </div>

      <div v-for="(page, index) in documentImages" :key="index" class="documentPage" @click="$emit('scrollToPage', index)">
        <v-img :src="page.path"></v-img>
        <div class="bar-action">
          <span class="page-number">{{ index + 1 }}</span>
          <v-btn v-if="false" class="btn btn-icon btn-minor btn-action" title="Delete">
            <v-icon size="small">mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {documentImagesInterface} from '@/views/documentsV2/NewDocumentFieldsV2.vue';

defineEmits(['scrollToPage']);

defineProps<{
  documentImages: documentImagesInterface[];
  documentFileName: string;
}>()
</script>

<style scoped>
.drawer-wrapper .docName {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


.documentPage .page-number {
  bottom: 0;
  color: #666;
  display: block;
  font-size: 12px;
  font-weight: 400;
  height: 28px;
  left: 0;
  letter-spacing: normal;
  line-height: 28px;
  padding: 0 9px;
  position: absolute;
  text-align: center;
  text-decoration: none;
  text-transform: none;
}
</style>
